<div class="d-flex profile-media">
    <img class="b-r-10" src="assets/images/dashboard/profile.png" alt="">
    <div class="flex-grow-1">
        <span>{{ userName }}</span>
      <p class="mb-0">
        {{ roleName }}
         <i class="middle fa-solid fa-angle-down"></i>
        </p>
    </div>
  </div>
  <ul class="profile-dropdown onhover-show-div">
    @for(item of profile; track item) {
        <!-- <li>
            <a href="javascript:void(0)">
                <app-feather-icon [icon]="item.icon"></app-feather-icon>
                <span>{{ item.title }}</span>
            </a>
        </li> -->
    }
    <li>
        <a href="javascript:void(0)" (click)="logout()">
            <app-feather-icon [icon]="'log-in'"></app-feather-icon>
            <span>Log out</span>
        </a>
    </li>
  </ul>